(function($) {

    class YoutubeFacade {
        constructor(container = null) {
            if(!container) {
                console.warn('Missing facade container')
                return
            }
            
            this.container = container
            this.button = this.container.querySelector('button')
            
            if(!this.button) {
                console.warn('Missing facade button')
                return
            }
            
            this.url = this.container.dataset.url
            
            if(!this.url) {
                this.container.remove()
                console.warn('Missing facade video URL')
                return
            }
            
            this.thumbnailQuality = this.container.dataset.thumbnailQuality ? this.container.dataset.thumbnailQuality : 'sddefault'
            
            this.delay = 0
            this.id = null
            this.timeout = null
            
            this._init()
        }
        
        _init() {
            this._getVideoID()
            this._getThumbnail()
            this.button.addEventListener('click', () => this._playVideo())
        }
        
        _getVideoID() {
            const regex = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|shorts\/|watch\?v=|\&v=)([^#\&\?]*).*/
            let videoId = this.url.match(regex)
            
    		this.id = videoId && videoId[2].length === 11 ? videoId[2] : null
        }
        
        _getThumbnail() {
    		/**
    		 * Thumbnail sizes
    		 * - default.jpg: 120x90
    		 * - mqdefault.jpg: 320x180
    		 * - hqdefault.jpg: 480x360
    		 * - sddefault.jpg: 640x480
    		 * - maxresdefault.jpg: 1280x720
     		*/
    		
    		const thumbnailUrl = this.id ? `https://img.youtube.com/vi/${this.id}/${this.thumbnailQuality}.jpg` : null
    		
    		if(thumbnailUrl) {
    			const thumbnail = document.createElement('img')
    			thumbnail.src = thumbnailUrl
    			thumbnail.width = 480
    			thumbnail.height = 360
    			thumbnail.alt = null
    			
    			this.button.innerHTML = null
    			this.button.appendChild(thumbnail)
    		}
        }
        
        setDelay(seconds = 0) {
            if(isNaN(seconds)) {
                console.warn('Timeout must be a number')
            }
            
            this.delay = seconds * 1000
        }
        
        _playVideo() {
            clearTimeout(this.timeout)
            
            this.timeout = setTimeout(() => {
                this.container.innerHTML = `<iframe width="560" height="315" src="https://www.youtube.com/embed/${this.id}?&autoplay=1" title="Player de video do YouTube" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>`
            }, this.delay)
        }
    }
    
    const youtubeFacade = document.querySelectorAll('.youtube-facade')
    
    if (youtubeFacade) {
        youtubeFacade.forEach(el => {
            new YoutubeFacade(el)
        })
    }
    
})(jQuery);